export enum NotificationEvents {
  PAYMENT_REQUEST_CHANGE = 'PAYMENT_REQUEST_CHANGE',
}

export enum ClientEvents {
  LOGIN_TOKEN = 'LOGIN_TOKEN',
}
